import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { BatchImportStoreService } from '../../batch-import';
import { DecaUploadFileDocumentsModalComponent } from '../deca-upload-file-documents-modal/deca-upload-file-documents-modal.component';

@Component({
  selector: 'lib-deca-upload-file-documents-button',
  templateUrl: './deca-upload-file-documents-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonButton],
})
export class DecaUploadFileDocumentsButtonComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly batchImportStoreService = inject(BatchImportStoreService);
  private readonly router = inject(Router);
  public readonly redirection = input.required<string>();

  async showUploadFreightFileModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: DecaUploadFileDocumentsModalComponent,
      componentProps: {},
      backdropDismiss: false,
    });
    modal.onDidDismiss().then((result) => {
      if (result.role === 'confirm') {
        setTimeout(() => {
          this.batchImportStoreService.reloadBatchImports();
          this.router.navigate([this.redirection()]);
        }, 2000);
      }
    });
    modal.present();
  }
}
